export default {"src":"/_next/static/media/good_lighting.fc20739c.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};